<template>
  <loading v-if="loading" />
  <div class="-mt-px" v-else-if="user && !error" :class="{ 'h-full': isOther }">
    <div :class="{ 'h-full': isOther }">
      <div
        class="bg-secondary-500 py-4 pb-8 mb-6"
        :class="{ 'h-full grid content-center': isOther }"
      >
        <div class="grid grid-cols-1-6-1 content-center justify-end">
          <div></div>
          <div class="flex items-center justify-center">
            <div class="w-32 h-32">
              <avatar class="profile-avatar" :avatar="user.avatar" />
            </div>
          </div>
          <div></div>
        </div>
        <div class="text-white text-center text-lg mt-4">
          <div class="uppercase font-medium tracking-widest mb-0 leading-none">{{ user.username }}</div>
          <div class="font-light" v-if="(isFriend || isOwn) && user.email">{{ user.email }}</div>
          <div class="mt-4" v-else-if="isOther">
            <div v-if="isFriendRequest">
              <div v-if="user.friend_request.direction === 'incoming'">
                <div
                  class="p-6 max-w-sm mx-auto my-6 bg-white text-black rounded-xl overflow-hidden"
                >
                  <div
                    class="mb-2 -mt-6 -ml-6 -mr-6 py-1 text-sm text-white tracking-wide font-medium bg-gray-800"
                  >
                    {{
                    $t("users.pending_incoming_friend_request", {
                    user: user.username,
                    })
                    }}
                  </div>
                  <div class="italic text-xl mt-4">{{ user.friend_request.message }}</div>
                </div>
                <div class="mt-4">
                  <wd-button
                    class="mr-2"
                    icon="Reject"
                    icon-size="1.3em"
                    white
                    @input="rejectFriendRequest"
                  >{{ $t("users.request.reject") }}</wd-button>
                  <wd-button
                    icon="Accept"
                    icon-size="1.3em"
                    white
                    @input="acceptFriendRequest"
                  >{{ $t("users.request.accept") }}</wd-button>
                </div>
              </div>
              <div v-else>
                <div>
                  {{
                  $t("users.pending_outgoing_friend_request", {
                  user: user.username,
                  })
                  }}
                </div>
              </div>
            </div>
            <wd-button v-else white @input="openFriendRequest">{{ $t("users.add_friend") }}</wd-button>
          </div>
        </div>
      </div>
    </div>
    <div class="data overflow-y-auto" v-if="isFriend || isOwn">
      <div class="max-w-md px-8 mx-auto mb-4 leading-snug grid justify-center">
        <p v-if="user.description">{{ user.description }}</p>
        <div v-else class="grid content-center text-gray-600">
          <p class="text-center mb-2">
            <icon name="Info" />
          </p>
          <p class="italic text-center">
            {{
            isOwn
            ? $t("users.you_have_no_description_message", )
            : $t("users.no_description_entered", {user: user.username})
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="h-full flex justify-center items-center">
    <p>{{ $t("users.request.no_user_profile_found") }}</p>
  </div>
</template>

<script>
const Avatar = require("@/modules/avatars/components/Avatar.vue").default;
const Loading = require("@/modules/core/components/Loading.vue").default;

import { User } from "@/modules/users/viewmodels/User";

export default {
  name: "UserProfileCurrent",
  mixins: [],
  data: () => ({
    user: {},
    active: false,
    error: null,
    isFriend: false,
    isFriendRequest: false,
    isOwn: true,
    loading: true
  }),
  props: {
    id: {
      type: String
    }
  },
  components: {
    Avatar
  },
  computed: {
    logged() {
      return this.$store.getters["auth/logged"];
    },
    isOther() {
      return !this.isOwn && !this.isFriend;
    }
  },
  methods: {
    editProfile() {
      this.$router.push("/profile-edit");
    },
    openFriendRequest() {
      this.$router.push("/friend-request/" + this.id);
    },
    acceptFriendRequest() {
      this.$store.getters["userfriendrequest/api"].Custom.Accept(
        this.user.friend_request.id
      ).then(e => {
        this.$store.dispatch(
          "userfriendrequest/removeIncomingFriendRequest",
          this.user.friend_request.id
        );
        this.goTo("/friends");
      });
    },
    rejectFriendRequest() {
      this.$store.getters["userfriendrequest/api"].Custom.Reject(
        this.user.friend_request.id
      ).then(e => {
        this.$store.dispatch(
          "userfriendrequest/removeIncomingFriendRequest",
          this.user.friend_request.id
        );
        this.goTo("/friends");
      });
    }
  },
  async created() {
    let ownId = this.$store.getters["auth/ownId"];
    if (this.id !== ownId) {
      if (this.id) {
        this.isOwn = false;
        this.user = await this.$store.getters["users/api"].Custom.User(this.id);
        this.isFriendRequest = this.user.friend_request
          ? this.user.friend_request
          : false;

        this.isFriend = await this.$store.getters[
          "userfriend/api"
        ].Custom.IsFriend(this.id);
      } else {
        this.user = await this.$store.getters["users/api"].Custom.Current();
      }
    }

    let headerElements = [
      {
        value: this.$t("users.profile"),
        location: "left",
        css: "font-medium tracking-wider"
      }
    ];

    if (this.isOwn) {
      headerElements.push({
        type: "icon",
        value: "Settings",
        location: "right",
        css: "cursor-pointer",
        action: () => {
          this.goTo("/profile-edit");
        }
      });
    }

    if (this.isFriend) {
      headerElements.push({
        type: "dropdown",
        location: "right",
        elements: [
          {
            value: this.$t("users.remove_friend"),
            action: async () => {
              let friendship = await this.$store.getters[
                "userfriend/api"
              ].Custom.FriendFriendship(this.id);
              await this.$store.getters["userfriend/api"].Destroy(
                friendship.id
              );
              this.goTo("/friends");
            }
          }
        ]
      });
    }

    this.$store.dispatch("header/update", {
      bg: "bg-secondary-500",
      elements: headerElements,
      backbutton: !this.isOwn || (this.isOwn && this.id),
      clear: true
    });

    this.loading = false;
  },
  mounted() {}
};
</script>
